export const M_AdvancedPromise_DefaultOptions = {
	repeatable: false,
	finallyExpectsData: false,
	as: null,
};
